// Lightweight, dependency-free CSV parsing for master imports.
// Pairs with utils/exportExcel.js (which writes CSVs that open in Excel).

// Parse CSV text into an array of row objects keyed by the header row.
// Handles quoted fields, escaped quotes (""), commas and newlines inside quotes,
// CRLF, and a leading BOM.
export function parseCSV(text) {
  if (!text) return [];
  text = text.replace(/^﻿/, '');
  const rows = [];
  let field = '', row = [], inQuotes = false, i = 0;
  while (i < text.length) {
    const c = text[i];
    if (inQuotes) {
      if (c === '"') {
        if (text[i + 1] === '"') { field += '"'; i += 2; continue; }
        inQuotes = false; i++; continue;
      }
      field += c; i++; continue;
    }
    if (c === '"') { inQuotes = true; i++; continue; }
    if (c === ',') { row.push(field); field = ''; i++; continue; }
    if (c === '\r') { i++; continue; }
    if (c === '\n') { row.push(field); rows.push(row); row = []; field = ''; i++; continue; }
    field += c; i++;
  }
  if (field.length || row.length) { row.push(field); rows.push(row); }
  if (!rows.length) return [];
  const headers = rows[0].map(h => h.trim());
  return rows.slice(1)
    .filter(r => r.some(c => (c || '').trim() !== ''))
    .map(r => {
      const o = {};
      headers.forEach((h, idx) => { o[h] = (r[idx] ?? '').trim(); });
      return o;
    });
}

// Build typed payload objects from parsed CSV rows using a column spec.
// columns: [{ key, label, type: 'text'|'number'|'bool', required }]
// Matches CSV headers to column labels (case-insensitive).
export function rowsToPayloads(rawRows, columns) {
  const out = [];
  rawRows.forEach((raw, idx) => {
    // case-insensitive header lookup
    const lower = {};
    Object.keys(raw).forEach(k => { lower[k.toLowerCase().trim()] = raw[k]; });
    const payload = {};
    const missing = [];
    columns.forEach(col => {
      let v = lower[col.label.toLowerCase()] ?? '';
      if (col.type === 'number') v = v === '' ? 0 : Number(v);
      else if (col.type === 'bool') v = /^(y|yes|true|1)$/i.test(v);
      payload[col.key] = v;
      if (col.required && (v === '' || v == null)) missing.push(col.label);
    });
    out.push({ rowNo: idx + 2, payload, missing });
  });
  return out;
}
